import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=5ff01be4&scoped=true"
import script from "./order-list.vue?vue&type=script&lang=js"
export * from "./order-list.vue?vue&type=script&lang=js"
import style0 from "./order-list.vue?vue&type=style&index=0&id=5ff01be4&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/shop/order-list.less?vue&type=style&index=1&id=5ff01be4&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff01be4",
  null
  
)

export default component.exports